import { addListsModalActionTypes } from './Constants';

export function getLists(id, type, generalType, groupId) {
	return {
		type: addListsModalActionTypes.GET_LIST_REQUEST,
		payload: {
			id,
			type,
			generalType,
			groupId,
		},
	};
}

export function getListsSuccess(data) {
	return {
		type: addListsModalActionTypes.GET_LIST_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getListsError(error) {
	return {
		type: addListsModalActionTypes.GET_LIST_ERROR,
		payload: {
			error,
		},
	};
}

export function toggleAddListModal(data) {
	return {
		type: addListsModalActionTypes.TOGGLE_ADD_LIST_MODAL,
		payload: {
			data,
		},
	};
}

export function clearState() {
	return {
		type: addListsModalActionTypes.CLEAR_ADD_LIST_MODAL_STATE,
	};
}
